import { ArrowRight } from 'lucide-react'
import { LocalizedLink } from '@/components/LocalizedLink'
import { cn } from '@/lib/utils'

interface TextSectionProps {
  heading: string
  body: string
  align?: 'left' | 'center'
  className?: string
  cta?: {
    label: string
    to: string
  }
}

export function TextSection({
  heading,
  body,
  align = 'left',
  className,
  cta,
}: TextSectionProps) {
  return (
    <section className={cn('py-20 md:py-28 bg-white border-t-4 border-brand-red', className)}>
      <div
        className={cn(
          'mx-auto max-w-7xl px-4 sm:px-6 lg:px-8',
          align === 'center' && 'text-center'
        )}
      >
        <h2 className="text-2xl md:text-4xl font-bold text-brand-dark mb-8">
          {heading}
        </h2>
        <p
          className={cn(
            'text-brand-text text-lg leading-relaxed',
            align === 'center' ? 'max-w-3xl mx-auto' : 'max-w-3xl'
          )}
        >
          {body}
        </p>
        {cta && (
          <div className={cn('mt-8', align === 'center' && 'flex justify-center')}>
            <LocalizedLink
              to={cta.to}
              className="group inline-flex items-center gap-2 text-brand-red font-semibold hover:gap-3 transition-all"
            >
              {cta.label}
              <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
            </LocalizedLink>
          </div>
        )}
      </div>
    </section>
  )
}
